import { AxiosRequestConfig } from 'axios';
import {
  FreezeTeamMembersPayload,
  TeamIdPayload,
  TeamMember,
  TeamMembersAddPayload,
  UnfreezeTeamMembersPayload,
} from 'Interfaces/Team';
import { TokenizedPayload, User, UserIdPayload } from 'Interfaces/User';

import Api from './Api';

class TeamApi extends Api {
  getTeamMembers = (params: AxiosRequestConfig['params'], config?: AxiosRequestConfig) =>
    this.request.get()('teams/members', { params, ...config });

  addTeamMembers = (values: TeamMembersAddPayload) =>
    this.request.post()<TeamMember>('add-teammates', values);

  deleteTeamMembers = (teamMemberIds: TeamMember['id'][]) => {
    return this.request.delete()(`remove-teammates`, {
      data: { ids: teamMemberIds },
    });
  };

  acceptInvite = ({ token, payload }: TokenizedPayload<TeamIdPayload>) => {
    return this.request.post(token)(`add-teammates/${payload.teamId}/accept_invite`);
  };

  upgradeToAdmin = (payload: UserIdPayload) => {
    return this.request.post()<User>(`teams/${payload.userId}/upgrade_to_admin`);
  };

  downgradeToUser = (payload: UserIdPayload) => {
    return this.request.post()<User>(`teams/${payload.userId}/downgrade_to_user`);
  };

  freezeTeamMembers = (payload: FreezeTeamMembersPayload) => {
    return this.request.post()(`freeze-teammates/freeze`, {
      ids: payload.teamMembersIds,
      freezeUntil: payload.freezeUntil,
    });
  };

  unfreezeTeamMembers = (payload: UnfreezeTeamMembersPayload) => {
    return this.request.post()(`freeze-teammates/unfreeze`, {
      ids: payload.teamMembersIds,
    });
  };
}

export default new TeamApi();
